import axios from "../utility/authAxios";
import { API_VERSION, AUTH_SERVICE_PATH } from "../config/axios";
import { setHttpParams } from "../utility/utils";

const AUTH_SERVICE_URI = `${API_VERSION}/${AUTH_SERVICE_PATH}`;

/**************** Popular services cards *****************************/
// get all cards list of specific page & section
export const getAllCards = async (page, section, params = {}) => {
    params = setHttpParams(params);
    return axios.get(
        API_VERSION + `/commerce/cards/${page}/${section}?${params}`
    );
};

// get card info for edit mood
export const getSpecificCard = async (page, section, id) => {
    return axios.get(
        API_VERSION + `/commerce/cards/${page}/${section}/${id}`
    );
};

// get specific service info for page & section id, need to add service card
export const getServiceInfo = async (page, section) => {
    return axios.get(API_VERSION + `/commerce/cards/${page}/${section}`);
};

// LATER: ass card service
export const createService = async (data) => {
    return axios.post(API_VERSION + `/commerce/cards`, data);
};
// delete specific service card
export const deleteSpecificService = async (id) => {
    return axios.delete(API_VERSION + `/commerce/cards/${id}`);
};

export const reorderCards = async (data) => {
    return axios.post(API_VERSION + `/commerce/cards`, data)
};

/** ********************* BFF Service's card ******************************************/
// get card info for edit mood
export const getSettings = async (key) => {
    return axios.get(API_VERSION + `/settings`);
};

// get card info for edit mood
export const getSpecificSetting = async (key) => {
    return axios.get(API_VERSION + `/commerce/settings/${key}`);
};

// get section list
export const getSectionList = async () => {
    return axios.get(API_VERSION + `/commerce/sections`);
};

export const getSectionListByPageSlug = async (slug) => {
    return axios.get(API_VERSION + `/commerce/sections/list/${slug}`);
};

export const getSection = async (id) => {
    return axios.get(API_VERSION + `/commerce/sections/${id}`);
}

export const createSection = async (data) => {
    return axios.post(API_VERSION + `/commerce/sections`, data);
}

export const getSectionOptions = async (slug) => {
    return axios.get(API_VERSION + `/commerce/sections/options/${slug}`);
}

export const deleteSection = async (id) => {
    return axios.delete(API_VERSION + `/commerce/sections/${id}`);
};

// section update
export const updateSection = async (id, data) => {
    return axios.put(API_VERSION + `/commerce/sections/${id}`, data);
}

export const updateSectionReorder = async (data) => {
    return axios.put(API_VERSION + `/commerce/sections/home-page/reorders`, data);
}

export const getSpecificSection = async (id) => {
    return axios.get(API_VERSION + `/commerce/section/home-page/${id}`);
}

export const updateSpecificSection = async (id, data) => {
    return axios.put(API_VERSION + `/commerce/section/home-page/${id}`, data);
}

export const createCard = async (data) => {
    return axios.post(API_VERSION + `/commerce/cards`, data);
}

export const getSpecificCards = async (slug, params={}) => {
    params = setHttpParams(params);
    return axios.get(API_VERSION + `/commerce/cards/${slug}?${params}`);
}

export const deleteCard = async (id) => {
    return axios.delete(API_VERSION + `/commerce/cards/${id}`);
}

export const getCardDetails = async (id) => {
    return axios.get(API_VERSION + `/commerce/cards/details/${id}`);
}

export const updateCard = async (id, data) => {
    return axios.put(API_VERSION + `/commerce/cards/${id}`, data);
}

export const updateCardReorder = async (data) => {
    return axios.put(API_VERSION + `/commerce/cards/reorders`, data);
}

export const getCardList = async (page, slug, params={}) => {
    params = setHttpParams(params);
    return axios.get(API_VERSION + `/commerce/cards/${page}/${slug}?${params}`);
}

export const getAllIssuers= async (params = {}) => {
    params = setHttpParams(params);
    return axios.get(`${AUTH_SERVICE_URI}/clients`);
};